import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '../../shared/network/data.service';
import { BenchmarksModel } from '../../shared/benchmarks/benchmarks-model';

export interface TrendModalData {
    projectId: string;
    viewId?: string;
    tabId?: string;
    cardIx: number;
    formCompIx?: number;
    benchmarksModel?: BenchmarksModel;
    tabIx?: number; // For main-fcst-walk component
    seqMode?: boolean; // the SEQ/TOT switch of the page that opens the modal (/cards), which its Trend shows and sets
}

@Component({
    selector: 'app-trend-modal',
    templateUrl: './trend-modal.component.html',
    styleUrls: ['./trend-modal.component.scss']
})
export class TrendModalComponent implements OnInit {
    public benchmarksModel: BenchmarksModel;
    public dataLoaded: boolean = false;
    public isMainFcstWalk: boolean = false;
    public seqMode: boolean;
    // Switched in the modal's Trend: the opener sets its own switch to it
    public seqModeChange = new EventEmitter<boolean>();
    // The formula component shown (-1: the outcome, undefined: the card's own driver), for the pinned tab's Trend
    private formCompIx: number | undefined;

    constructor(@Inject(MAT_DIALOG_DATA) public data: TrendModalData, public dialogRef: MatDialogRef<TrendModalComponent>, private dataService: DataService) {
        // Check if opened from main-fcst-walk (no viewId/tabId)
        this.isMainFcstWalk = this.data.viewId === undefined;
        this.seqMode = this.data.seqMode ?? true;
    }

    ngOnInit(): void {
        this.loadBenchmarksData(this.data.formCompIx);
    }

    private async loadBenchmarksData(formCompIx?: number): Promise<void> {
        this.formCompIx = formCompIx;
        try {
            this.dataLoaded = false;
            
            let url: string;
            // Check if this is for main-fcst-walk (no viewId/tabId)
            if (this.data.viewId === undefined) {
                // Main-fcst-walk mode
                url = `benchmarksForMainFcstWalk?projectId=${this.data.projectId}`;
                if (this.data.tabIx !== undefined) {
                    url += `&tabIx=${this.data.tabIx}&cardIndex=${this.data.cardIx}`;
                }
            } else {
                // Regular cards mode
                url = `benchmarks?viewId=${this.data.viewId}&tabId=${this.data.tabId}&cardIndex=${this.data.cardIx}`;
            }
            
            if (formCompIx !== undefined) {
                url += `&formCompIx=${formCompIx}`;
            }
            
            const result = await this.dataService.get<BenchmarksModel>(url);
            this.benchmarksModel = result;
            this.dataLoaded = true;
            //console.log('Benchmarks result loaded for modal:', result);
        } catch (error) {
            console.error('Error getting benchmarks:', error);
            this.dataLoaded = true;
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onPin(): void {
        this.dialogRef.close({ shouldExplode: true, cardIx: this.data.cardIx, formCompIx: this.formCompIx });
    }

    onFormCompChanged(formCompIx: number): void {
        this.loadBenchmarksData(formCompIx);
    }

    onFcstSaved(event: { formCompIx: number }): void {
        this.dialogRef.close({ shouldReload: true, formCompIx: event.formCompIx });
    }

    onSeqModeChange(seqMode: boolean): void {
        this.seqMode = seqMode;
        this.seqModeChange.emit(seqMode);
    }
}
